import createVideoCardsBiLogger from '@wix/wix-vod-shared/src/common/bi/create-video-cards-bi-logger';
import sharedBiLogger from 'shared/bi/bi';


export default createVideoCardsBiLogger(sharedBiLogger);



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/bi-loggers/video-cards-bi-logger.js